export default {
  hero_title: "Logre sin esfuerzo el cumplimiento de carbono de la UE-CBAM",
  hero_subtitle:
    "Una plataforma de cálculo de carbono para PYME basada en factores oficiales/personalizados de la UE para generar rápidamente informes compatibles.",
  what_is_taxecobit: "¿Qué es TaxEcoBit?",
  taxecobit_description:
    "TaxEcoBit es una plataforma de automatización de cumplimiento diseñada para empresas afectadas por el Mecanismo de Ajuste Fronterizo de Carbono (CBAM) de la UE. Ayudamos a importadores, fabricantes y PYME a calcular emisiones de carbono específicas de productos, generar documentos compatibles con la CBAM y reducir riesgos regulatorios.",
  taxecobit_benefits: "Con TaxEcoBit, los usuarios pueden:",
  benefit_accurate_calculations:
    "Realizar cálculos precisos de carbono utilizando factores de emisión oficiales y personalizados",
  benefit_cbam_documents: "Generar documentos compatibles con la CBAM para presentar",
  benefit_carbon_cost_tracking:
    "Monitorear el impacto del costo del carbono y optimizar la eficiencia operativa",
  benefit_api_integration:
    "Integrar flujos de trabajo de cumplimiento sin problemas con sistemas ERP y de cadena de suministro a través de API",
  taxecobit_conclusion:
    "Al reemplazar cálculos manuales en hojas de cálculo y la dependencia de consultores, TaxEcoBit permite un cumplimiento más rápido, confiable y con menores costos operativos.",
  register_now: "Registrarse ahora",
  experience_calculator: "Probar calculadora CBAM",
  try_cbam_calculator: "Usar calculadora CBAM",
  try_cbam_quick_check: "Probar verificación rápida CBAM",
  download_sample_report: "Descargar informe de muestra",
  pdf_report: "Informe PDF",
  excel_report: "Informe Excel",
  precise: "Preciso",
  how_it_works: "Cómo funciona",
  precise_description:
    "Basado en factores oficiales/personalizados de la UE con un error de cálculo < 5%, compatible con los requisitos de cumplimiento.",
  efficient: "Eficiente",
  efficient_description:
    "Admite cálculos por lotes, genera automáticamente informes PDF/Excel con configuración flexible.",
  sme_focused: "Enfocado en PYME",
  sme_focused_description:
    "No se requiere experiencia profesional, interfaz intuitiva para una rápida incorporación.",
  api_support: "Soporte API",
  api_support_description:
    "Fácil integración con sistemas ERP/e-commerce para informes automatizados de cumplimiento.",
};
